import type { ReactNode } from 'react';

/** Minimal placeholder page so the router resolves + guards are demonstrable (feature logic is P2+). */
export function PlaceholderPage({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children?: ReactNode;
}) {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
      {children}
    </div>
  );
}
